var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.1 490.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M490.06,490.06h-100.69v-171.5c0-47.02-17.87-73.3-55.08-73.3-40.49,0-61.64,27.35-61.64,73.3v171.5h-97.04V163.35h97.04v44.01s29.18-53.99,98.51-53.99,118.91,42.32,118.91,129.84v206.85ZM59.84,120.57C26.78,120.57,0,93.58,0,60.29S26.78,0,59.84,0s59.82,26.99,59.82,60.29-26.77,60.29-59.82,60.29ZM9.73,490.06h101.19V163.35H9.73v326.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.7794f0193e3d035cefd604d526d8985c.svg";
export { ForwardRef as ReactComponent };